<template>
  <div class="difficulty">
    <div v-if="difficulty === 1" class="difficulty__level-zero">
      <img
        src="@/assets/icons/difficulty/informative.png"
        class="difficulty__level-zero-img"
      />
    </div>
    <BeginnerDifficulty
      v-if="difficulty === 2"
      class="difficulty__level-one"
    ></BeginnerDifficulty>
    <IntermediateDifficulty
      v-if="difficulty === 3"
      class="difficulty__level-two"
    ></IntermediateDifficulty>
    <AdvancedDifficulty
      v-if="difficulty === 4"
      class="difficulty__level-three"
    ></AdvancedDifficulty>
    <ExpertDifficulty
      v-if="difficulty === 5"
      class="difficulty__level-four"
    ></ExpertDifficulty>
    <div class="difficulty__label">{{ difficultyLabel }}</div>
  </div>
</template>

<script>
import BeginnerDifficulty from '@/assets/icons/difficulty/BeginnerDifficulty.svg'
import IntermediateDifficulty from '@/assets/icons/difficulty/IntermediateDifficulty.svg'
import AdvancedDifficulty from '@/assets/icons/difficulty/AdvancedDifficulty.svg'
import ExpertDifficulty from '@/assets/icons/difficulty/ExpertDifficulty.svg'

export default {
  name: 'DifficultyComponent',
  components: {
    BeginnerDifficulty: { ...BeginnerDifficulty, name: 'BeginnerDifficulty' },
    IntermediateDifficulty: {
      ...IntermediateDifficulty,
      name: 'IntermediateDifficulty',
    },
    AdvancedDifficulty: { ...AdvancedDifficulty, name: 'AdvancedDifficulty' },
    ExpertDifficulty: { ...ExpertDifficulty, name: 'ExpertDifficulty' },
  },
  props: ['difficulty'],
  computed: {
    difficultyLabel() {
      switch (this.difficulty) {
        case 1:
          return 'Informative'
        case 2:
          return 'Novice'
        case 3:
          return 'Professional'
        case 4:
          return 'Advanced'
        case 5:
          return 'Expert'
        default:
          return 'N/A'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.difficulty {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  align-items: center;
  &__label {
    display: none;
    color: var(--white);
    @include tablet {
      display: block;
    }
  }
  &__level-one,
  &__level-two,
  &__level-three,
  &__level-four,
  &__level-five {
    width: 20px;
    margin-right: 10px;
  }
  &__level-zero-img {
    width: 20px;
    margin-right: 10px;
  }
  &__level-one {
    fill: var(--difficulty-level-one);
  }
  &__level-two {
    fill: var(--difficulty-level-two);
  }
  &__level-three {
    fill: var(--difficulty-level-three);
  }
  &__level-four {
    fill: var(--difficulty-level-four);
  }
}
</style>
